import { Box, Stack } from '@mui/material';
import { AiAgentWithFacts } from '../../../aiAgentCenter/aiAgentsConsts';
import useAgentsChats from '../../../aiAgentCenter/useAgentsChats';
import MegaphoneIconMonitoring from '../../../aiAgentCenter/svg/facts/megaphoneIconMonitoring.svg?react';
import CubeIconMonitoring from '../../../aiAgentCenter/svg/facts/cubeIconMonitoring.svg?react';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../../../services/events';

export const AgentPopoverCard = ({
  agent,
  objectLabel,
  agentIssues,
  isLast,
  isActivating,
  disableButton,
  onActivate,
}: {
  agent: AiAgentWithFacts;
  objectLabel: string;
  agentIssues: number;
  isLast?: boolean;
  isActivating?: boolean;
  disableButton?: boolean;
  onActivate?: () => void;
}) => {
  const { setAgentClickHandler } = useAgentsChats();
  const sendBiEvent = useSendBiEvent();

  return (
    <Box
      key={agent.id}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1,
        '&:hover': {
          backgroundColor: colors.grey[100],
          cursor: 'pointer',
        },
        borderBottom: isLast ? 'none' : `1px solid ${colors.grey[300]}`,
      }}
      onClick={() => (onActivate ? null : setAgentClickHandler({ agent }))}
    >
      <Stack gap={1}>
        <Typography variant="body-medium">{agent.name}</Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          <CubeIconMonitoring />
          <Typography variant="body" color={colors.grey[700]}>
            {objectLabel}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        {onActivate ? (
          <Button
            variant="flat-grey"
            loading={isActivating}
            disabled={disableButton}
            underlined
            size="small"
            onClick={() => {
              sendBiEvent({ name: AI_AGENTS_EVENTS.monitoringWidgetActivateAgent });
              onActivate();
            }}
          >
            Activate
          </Button>
        ) : (
          <>
            <MegaphoneIconMonitoring />
            <Typography variant="body-medium" color={colors.grey[700]}>
              {agentIssues} Active {agentIssues === 1 ? 'Issue' : 'Issues'}
            </Typography>
          </>
        )}
      </Stack>
    </Box>
  );
};
